import { map as rxjsmap } from 'rxjs';


import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

import { BaseServices } from './../../kuba.services';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class EditorContactsServices {

    constructor(private http: HttpClient) {
    }

    contactById(id: number) {
        return this.http
            .get(
            environment.BASE_URL + '/contact/' + id,

            ).pipe(rxjsmap((result: any) => result));
    }
    saveContact(data: any) {
        return this.http
            .post(
            environment.BASE_URL + '/contact',
            data,

            ).pipe(rxjsmap(result => result));
    }
    updateContact(data: any) {
        return this.http
            .put(
            environment.BASE_URL + '/contact',
            data,

            ).pipe(rxjsmap(result => result));
    }
    statusUpdate(id: number, status: number) {
        return this.http
            .put(
            `${environment.BASE_URL}/contact/${id}/${status}`,
              {}
            ).pipe(rxjsmap(result => result));
    }
    deleteAll(Ids: any) {
        return this.http
            .put(
            environment.BASE_URL + '/contacts',
            Ids,

            ).pipe(rxjsmap(result => result));
    }
    getContactFunctions() {
        return this.http
            .get(
            environment.BASE_URL + '/contactfunctions/contactFunctions',

            ).pipe(rxjsmap(result => result));
    }
    saveContactFunction(data: any) {
        return this.http
            .post(
            environment.BASE_URL + '/contacFunction',
            data,

            ).pipe(rxjsmap(result => result));
    }
    updateContactFunction(data: any) {
        return this.http
            .put(
            environment.BASE_URL + '/contactfunction',
            data,

            ).pipe(rxjsmap(result => result));
    }
    deleteContactFunction(id: number) {
        return this.http
            .delete(
            environment.BASE_URL + '/contactfunctions/' + id,

            ).pipe(rxjsmap(result => result));
    }
    getContactByBusiness(businessId: number) {
        return this.http
            .get<any>(
            environment.BASE_URL +
            '/customercontactbybusiness/' +
            businessId,

            ).pipe(rxjsmap(result => result));
    }
    getContactUser(featureKey: number) {
        return this.http
            .get(
            environment.BASE_URL + '/contactUser/' + featureKey,

            ).pipe(rxjsmap(result => result));
    }
    checkEmail(email: string) {
        return this.http
            .get(
            environment.BASE_URL + '/check-email/' + email,

            ).pipe(rxjsmap(result => result));
    }

    getKubaNorgeAs() {
        return this.http
            .get(
            environment.BASE_URL + '/KubaNorge',

            ).pipe(rxjsmap(result => result));
    }
}
